// Utility function to check if a value is in the enum
export function isValidEnumValue<T extends object>(enumObj: T, value: any): value is T[keyof T] {
    return Object.values(enumObj).includes(value);
}

export function getValueIfPropertyExists<T extends object, V>(obj: T, property: string, valueIfNotExists: V): V {
    if (property in obj) {
        return (obj as any)[property] as V;
    }

    return valueIfNotExists;
}